import { render, staticRenderFns } from "./handled.vue?vue&type=template&id=33fa7948"
import script from "./handled.vue?vue&type=script&lang=js"
export * from "./handled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports